import { DEFAULT_ADMIN_SETTINGS } from '../../../config/settingsConfig';
import {
    type AssistantType,
    type GradebookType,
    type HostType,
    type OrganizationType,
    type RosterType,
    type StudentType,
    type DocumentType,
    type ProctoringType,
    type TerminologySettings
} from '../../../types/adminConfig';
import { AssistantsTitle, HostTitle, RosterTitle, StudentsTitle, GradebookTitle, DocumentTitle, ProctoringTitle } from '../config/adminSettingsConfig';

const validateHostTitle = (hostTitle, organizationType: OrganizationType): HostType => {
    if (!hostTitle || !Object.values(HostTitle).includes(hostTitle)) {
        return DEFAULT_ADMIN_SETTINGS[organizationType].terminologySettings.hostTitle;
    }

    return hostTitle;
};

const validateAssistantsTitle = (assistantsTitle, organizationType: OrganizationType): AssistantType => {
    if (!assistantsTitle || !Object.values(AssistantsTitle).includes(assistantsTitle)) {
        return DEFAULT_ADMIN_SETTINGS[organizationType].terminologySettings.assistantsTitle;
    }
    return assistantsTitle;
};

const validateStudentTitle = (studentsTitle, organizationType: OrganizationType): StudentType => {
    if (!studentsTitle || !Object.values(StudentsTitle).includes(studentsTitle)) {
        return DEFAULT_ADMIN_SETTINGS[organizationType].terminologySettings.studentsTitle;
    }
    return studentsTitle;
};

const validateRosterTitle = (rosterTitle, organizationType: OrganizationType): RosterType => {
    if (!rosterTitle || !Object.values(RosterTitle).includes(rosterTitle)) {
        return DEFAULT_ADMIN_SETTINGS[organizationType].terminologySettings.rosterTitle;
    }
    return rosterTitle;
};

const validateGradebookTitle = (gradebookTitle, organizationType: OrganizationType): GradebookType => {
    if (!gradebookTitle || !Object.values(GradebookTitle).includes(gradebookTitle)) {
        return DEFAULT_ADMIN_SETTINGS[organizationType].terminologySettings.gradebookTitle;
    }
    return gradebookTitle;
};
const validateDocumentTitle = (documentTitle, organizationType: OrganizationType): DocumentType => {
    if (!documentTitle || !Object.values(DocumentTitle).includes(documentTitle)) {
        return DEFAULT_ADMIN_SETTINGS[organizationType].terminologySettings.documentTitle;
    }
    return documentTitle;
};
const validateProctoringTitle = (proctoringTitle, organizationType: OrganizationType): ProctoringType => {
    if (!proctoringTitle || !Object.values(ProctoringTitle).includes(proctoringTitle)) {
        return DEFAULT_ADMIN_SETTINGS[organizationType].terminologySettings.proctoringTitle;
    }
    return proctoringTitle;
};

const validateTerminologySettings = (terminologySettings: TerminologySettings, organizationType: OrganizationType): TerminologySettings => {
    const validatedTerminology = { ...terminologySettings };

    validatedTerminology.hostTitle = validateHostTitle(terminologySettings.hostTitle, organizationType);
    validatedTerminology.assistantsTitle = validateAssistantsTitle(terminologySettings.assistantsTitle, organizationType);
    validatedTerminology.studentsTitle = validateStudentTitle(terminologySettings.studentsTitle, organizationType);
    validatedTerminology.rosterTitle = validateRosterTitle(terminologySettings.rosterTitle, organizationType);
    validatedTerminology.gradebookTitle = validateGradebookTitle(terminologySettings.gradebookTitle, organizationType);
    validatedTerminology.documentTitle = validateDocumentTitle(terminologySettings.documentTitle, organizationType);

    return validatedTerminology;
};

export default validateTerminologySettings;

export { validateHostTitle, validateRosterTitle, validateAssistantsTitle, validateStudentTitle, validateGradebookTitle, validateDocumentTitle, validateProctoringTitle };
